import { useState } from 'react';
import ImageLightbox from '@/components/ui/ImageLightbox';
import useTranscriptPanelStore from '@/store/TranscriptPanelStore';

interface NotableVisual {
  url: string;
  type: string;
  caption?: string;
  respondentIndex?: number;
  conversationId?: string;
}

interface NotableVisualsGridProps {
  visuals: NotableVisual[];
}

function NotableVisualsGrid({ visuals }: NotableVisualsGridProps) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const { open: openTranscriptPanel } = useTranscriptPanelStore();

  const imageOnlyVisuals = visuals.filter((v) => v.type === 'image');

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {visuals.map((visual, index) => (
          <div key={index} className="flex flex-col gap-2">
            {visual.type === 'image' ? (
              <button
                type="button"
                onClick={() => {
                  const imageOnlyIndex =
                    visuals.slice(0, index + 1).filter((v) => v.type === 'image').length - 1;
                  setLightboxIndex(imageOnlyIndex);
                  setLightboxOpen(true);
                }}
                className="w-full focus:outline-none"
              >
                <img
                  src={visual.url}
                  alt={visual.caption}
                  className="w-full h-64 object-cover rounded-lg border border-neutral-200 hover:opacity-90 transition-opacity cursor-pointer"
                />
              </button>
            ) : (
              <video
                src={visual.url}
                controls
                preload="metadata"
                className="w-full h-64 object-cover rounded-lg border border-neutral-200"
              />
            )}
            {visual.caption && (
              <p className="text-sm text-neutral-600 leading-relaxed">{visual.caption}</p>
            )}
            {visual.respondentIndex !== undefined && (
              visual.conversationId ? (
                <button
                  type="button"
                  onClick={() => openTranscriptPanel(visual.conversationId!)}
                  className="text-xs font-medium text-primary hover:underline w-fit"
                >
                  Respondent #{visual.respondentIndex}
                </button>
              ) : (
                <p className="text-xs text-neutral-400">Respondent #{visual.respondentIndex}</p>
              )
            )}
          </div>
        ))}
      </div>

      <ImageLightbox
        images={imageOnlyVisuals.map((v) => ({
          url: v.url,
          caption: v.caption,
          respondent_index: v.respondentIndex,
        }))}
        initialIndex={lightboxIndex}
        open={lightboxOpen}
        onOpenChange={setLightboxOpen}
      />
    </>
  );
}

export default NotableVisualsGrid;
